import { lazy, mixed } from 'yup'

export const strippedSchemaWhenNull = schema =>
  lazy(value => (value === null ? mixed().strip() : schema))
